import(/* webpackMode: "eager" */ "/opt/demo5-build/app/global-error.tsx");
